import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { getProductForUserSegment } from '../../../../store/slices/paymentsSlice';
import PaymentButton, { paymentBtnType } from '../../../common/PaymentButton';
import styles from '../styles.module.scss';

const ProductPaymentContent = () => {
    const { t } = useTranslation();
    // HORO-10449: subscribers/trial subscribers see the 200-message bundle,
    // registered non-subscribers see the 20-message one.
    const product = useSelector(getProductForUserSegment);

    // No bundle for this customer — an unlimited plan has nothing to top up.
    // Without this the popup still rendered, with the count and price blank.
    if (!product) return null;

    const messagesCount = product?.limits?.messages?.count || '';
    const price = product?.price?.currency?.symbol + product?.price?.value || '';

    return (
        <>
            <h2 className={styles.title}>{t('pages.payment.advice')}</h2>
            <p className={styles.text}>{t('pages.payment.moreMessages', { messagesCount, price })}</p>
            <PaymentButton text={t('buttons.save33')} type={paymentBtnType.product} googleEvent={'chatPopup'} />
        </>
    );
};

export default ProductPaymentContent;
